<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="pa-0">
        <v-alert dense type="info" text class="mb-2">{{
          formatDate(calday)
        }}</v-alert>

        <v-alert
          dense
          text
          outlined
          color="teal lighten-4"
          class="mt-2 mb-0 pt-2 pb-4"
        >
          <p class="body-2 black--text pa-0 ma-0 mt-2">
            今月の支援入力確認状況
          </p>
          <v-divider class="mb-2"></v-divider>
          <v-badge
            bordered
            color="error"
            :content="mi"
            :value="mi"
            overlap
            class="mr-4 mt-3"
          >
            <v-btn
              class="white--text"
              color="error"
              depressed
              small
              @click="link('/kiroku')"
              >今日までの未入力</v-btn
            >
          </v-badge>

          <v-badge
            bordered
            color="success"
            :content="su"
            :value="su"
            overlap
            class="mr-4 mt-3"
          >
            <v-btn
              class="white--text"
              color="success"
              depressed
              small
              @click="link('/kiroku')"
              >入力済み</v-btn
            >
          </v-badge>
        </v-alert>

        <v-row>
          <v-col cols="12">
            <v-card outlined>
              <v-card-title>
                <v-icon large left>assignment</v-icon>
                <span class="title font-weight-light"
                  >{{ this.$store.getters.auth.name }}さん担当シフト</span
                >
              </v-card-title>

              <v-card-subtitle
                >本日から今週分の担当シフト一覧です。</v-card-subtitle
              >

              <v-img height="5" src="@/assets/banner01.png"></v-img>

              <v-card-text>
                <p
                  v-for="v in items"
                  :key="v.id"
                  :class="{ cancel: v.cancel, del: v.del }"
                  class="mb-0"
                  style="font-size: 120%; color: black"
                >
                  {{ formatDate(v.date) }}
                  {{
                    splitBlank(v.rimyoji) +
                    splitBlank(v.riname) +
                    " " +
                    v.kaisi +
                    "-" +
                    v.syuryo +
                    " "
                  }}
                  {{
                    splitBlank(v.staffname) +
                    " " +
                    splitBlank(v.dokoname) +
                    " " +
                    v.mark
                  }}
                </p>
              </v-card-text>

              <v-img height="5" src="@/assets/banner01.png"></v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined color="success" @click="link('/month')">
                  <v-icon right>event</v-icon>月間シフト
                </v-btn>
                <v-btn outlined color="success" @click="link('/week')">
                  <v-icon right>event</v-icon>週間シフト
                </v-btn>
                <v-btn outlined color="indigo" @click="link('/kiroku')">
                  <v-icon right>create</v-icon>記録入力
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card outlined>
              <v-card-title>
                <v-icon large left>perm_contact_calendar</v-icon>
                <span class="title font-weight-light"
                  >業務報告＆利用者様情報共有</span
                >
              </v-card-title>

              <v-card-subtitle>業務報告＆利用者様別のお知らせ</v-card-subtitle>

              <v-img height="5" src="@/assets/banner05.png"></v-img>

              <v-card-text>
                <p
                  v-for="v in riinfos"
                  :key="v.id"
                  class="ma-0 pa-0"
                  style="font-size: 100%; color: black"
                >
                  <v-chip
                    class="ma-2"
                    color="red"
                    text-color="white"
                    small
                    v-if="v.gyomu === 1"
                  >
                    事故・ヒヤリ
                  </v-chip>
                  <v-chip
                    class="ma-2"
                    color="success"
                    text-color="white"
                    small
                    v-if="v.gyomu === 2"
                  >
                    連絡
                  </v-chip>
                  <v-chip
                    class="ma-2"
                    color="primary"
                    text-color="white"
                    small
                    v-if="v.gyomu === 3"
                  >
                    報告
                  </v-chip>
                  {{ formatDate(v.jdate) }} {{ v.riname }}
                  {{ v.text | truncate }} {{ v.staffname }}
                </p>
              </v-card-text>

              <v-img height="5" src="@/assets/banner05.png"></v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined color="orange" @click="link('riinfo')">
                  <v-icon right>create</v-icon>一覧画面へ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col cols="12">
            <v-card outlined>
              <v-card-title>
                <v-icon large left>business</v-icon>
                <span class="title font-weight-light">会社からのお知らせ</span>
              </v-card-title>

              <v-card-subtitle>会社からの通達、連絡事項など</v-card-subtitle>

              <v-img height="5" src="@/assets/banner13.png"></v-img>

              <v-card-text>プログラム実装中近日公開</v-card-text>

              <v-img height="5" src="@/assets/banner13.png"></v-img>
            </v-card>
          </v-col>
        </v-row> -->
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Common from "@/components/Common";
import moment from "moment";
export default {
  filters: {
    truncate: function(value) {
      var length = 15;
      var ommision = "...";
      if (value.length <= length) {
        return value;
      }
      return value.substring(0, length) + ommision;
    }
  },
  mixins: [Common],
  data: () => ({
    mi: 0,
    su: 0,
    ri: 0,
    items: [],
    witems: [],
    riinfos: [],
    calday: moment(),
    weather: [],
    alert: true
  }),
  created() {
    this.kousin();
    this.count();
  },

  mounted() {},

  methods: {
    link(item) {
      this.$router.push(item);
    },
    logs(logid) {
      if (logid) {
        return "[確認済み]";
      } else {
        return "[未確認]";
      }
    },
    formatDate: function(date) {
      return moment(date).format("MM/DD (ddd)");
    },

    count() {
      var self = this;
      this.$axios
        .post(
          this.url + "getMiCount.php",
          JSON.stringify({
            kaisi: moment(this.calday).format("YYYY-MM-") + "01",
            syuryo: moment(this.calday).format("YYYY-MM-DD"),
            userid: this.$store.getters.auth.id,
            role: this.$store.getters.auth.role
          })
        )
        .then(function(res) {
          self.mi = res.data.mi;
        });

      this.$axios
        .post(
          this.url + "getSuCount.php",
          JSON.stringify({
            kaisi: moment(this.calday).format("YYYY-MM-") + "01",
            syuryo: moment(this.calday)
              .endOf("month")
              .format("YYYY-MM-DD"),
            userid: this.$store.getters.auth.id,
            role: this.$store.getters.auth.role
          })
        )
        .then(function(res) {
          self.su = res.data.su;
        });
    },

    doko() {
      this.items.forEach(v => {
        this.witems.forEach(w => {
          if (v.staffid != w.staffid && v.date == w.date && v.riid == w.riid) {
            if (
              moment(w.date + " " + w.kaisi).isBetween(
                moment(v.date + " " + v.kaisi),
                moment(v.date + " " + v.syuryo),
                null,
                "[)"
              )
            ) {
              v.doko = w.staffname;
            }

            if (
              moment(v.date + " " + v.kaisi).isBetween(
                moment(w.date + " " + w.kaisi),
                moment(w.date + " " + w.syuryo),
                null,
                "[)"
              )
            ) {
              v.doko = w.staffname;
            }
          }
        });
      });
    },

    splitBlank(text) {
      if (text == null) return "";
      var r = text.replace("　", " ").split(" ")[0];
      return r;
    },

    kousin() {
      var self = this;
      this.$axios
        .post(
          this.url + "shift.php",
          JSON.stringify({
            kaisi: moment(this.calday).format("YYYY-MM-DD"),
            syuryo: moment(this.calday)
              .add(7, "days")
              .format("YYYY-MM-DD"),
            today: "",
            order: "hiduke",
            id: this.$store.getters.auth.id,
            role: "top"
          })
        )
        .then(function(res) {
          self.items = res.data;
        });

      this.$axios
        .post(
          this.url + "getRiinfo.php",
          JSON.stringify({
            kaisi: moment(this.calday).format("YYYY-MM-DD"),
            syuryo: moment(this.calday)
              .add(1, "months")
              .format("YYYY-MM-DD"),
            id: this.$store.getters.auth.id,
            role: this.$store.getters.auth.role,
            limit: 10
          })
        )
        .then(function(res) {
          self.riinfos = res.data;
        });
    }
  }
};
</script>

<style scoped>
p.cancel {
  text-decoration: line-through;
}

p.del {
  display: none;
}
</style>